import Translator from "Languages/Utility/Translator";
import React from "react";

export default function BankTransactionRedirect() {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center shadow-lg py-3 px-5" style={{'borderRadius':'10px'}}>
            <strong style={{'fontSize':'18px'}}>
                <Translator id={'payment_transferring'} noSpan />
            </strong>
        </div>
    );
}
